import { useParams } from "react-router-dom";
import { sanitizeGameId } from "@pose-party/data";

export const useGameIdParam = () => {
  const { gameId } = useParams<{ gameId: string }>();
  return sanitizeGameId(gameId);
};
